module.exports = {
  NODE_ENV: '"production"',
  API_LOCATION: '"http://example.com/api/v1"',
};
